import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from '../../services/componentheader.service';
import { SchoolmanagementService } from '../../services/schoolmanagement.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ModulemanagementService } from '../../services/modules/modulemanagement.service';
import { AdminAction } from '../../models/adminaction.model';
declare const $: any;

@Component({
  selector: 'app-addstudentusers',
  templateUrl: './addstudentusers.component.html',
  styleUrls: ['./addstudentusers.component.css']
})
export class AddstudentusersComponent implements OnInit {
  @ViewChild('email') email: ElementRef;
  moduleid: number;
  schoolid: number;
  moduleinfo: any;
  selectedBatchId: number;
  batches: AdminAction[] = []
  allowBatches: boolean;

  constructor(private toastr: ToastrService, private headerinfo: ComponentheaderService,
    private schoolmanager: SchoolmanagementService, private route: ActivatedRoute,
    public modulemanager: ModulemanagementService, private router: Router, private cdr: ChangeDetectorRef) { }

  async ngOnInit() {
    try{
      this.moduleid = this.route.snapshot.queryParams.moduleid;
      this.headerinfo.setHeaderDisplay(
        `Add Student`,
        [
          {
            displaytext: 'School',
            route: `/user/schoolhome`,
            //params: { moduleID: this.moduleid },
          },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.moduleid },
          },
          {
            displaytext: `Add Unregistered Student`,
            route: `/user/addstudent`,
            params: this.route.snapshot.queryParams,
          },
        ],
        []
      );
      this.schoolid = await this.schoolmanager.getSchoolIdFromSubdomain().toPromise();
      let schdata: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
      this.allowBatches = schdata?.allowBatches;
      if (this.allowBatches){
        let moduleBatches = await this.modulemanager.getModuleBatches(this.moduleid).toPromise();
  
        moduleBatches.forEach(b => {
          let obj = new AdminAction();
          obj.displaytext = b.name;
          obj.params = {id: b.id};
          if (!this.batches.find(a => a.displaytext == b.name))
            this.batches.push(obj);
        });
      };
    }
    catch(e){
      console.log('error:', e);      
    }    
  }
  
  async addStudent() {
    try{
      if (!this.email.nativeElement.value) {
        this.toastr.error("Enter User Email");
        throw new Error("Enter User Email");
      }   
      if (this.moduleid > 0) {
        let data = [{
          moduleId: this.moduleid,
          email: this.email.nativeElement.value,
          schoolId: this.schoolid,
          batchId: this.selectedBatchId
        }];
        let res = await this.modulemanager.enrollByAdmin(data).toPromise();
        this.toastr.success('Sucessful');
        this.email.nativeElement.value = '';
      }
    }    
    catch(e){
      this.toastr.error(e.message)
      console.log('error:', e);      
    }
    finally{
      location.reload();
    }
  }

  setBatchId(id: any){
    this.selectedBatchId = id;
  }
}
